import { render, staticRenderFns } from "./UserEvaluation.vue?vue&type=template&id=b22a3f38&"
import script from "./UserEvaluation.vue?vue&type=script&lang=js&"
export * from "./UserEvaluation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports